{
  "version": 1,
  "enabled": true,
  "timeZone": "UTC",
  "resetAfterMissedDay": true,
  "days": [
    { "id": "daily-1", "day": 1, "rewards": [{ "type": "coins", "amount": 20 }] },
    { "id": "daily-2", "day": 2, "rewards": [{ "type": "coins", "amount": 25 }] },
    { "id": "daily-3", "day": 3, "rewards": [{ "type": "coins", "amount": 30 }] },
    { "id": "daily-4", "day": 4, "rewards": [{ "type": "coins", "amount": 40 }] },
    { "id": "daily-5", "day": 5, "rewards": [{ "type": "coins", "amount": 50 }] },
    { "id": "daily-6", "day": 6, "rewards": [{ "type": "coins", "amount": 75 }] },
    { "id": "daily-7", "day": 7, "rewards": [{ "type": "inventory", "itemType": "avatar_frame", "itemId": "gold-ring", "gameId": null, "duplicateReward": { "type": "coins", "amount": 100 } }] },
    { "id": "daily-8", "day": 8, "rewards": [{ "type": "coins", "amount": 20 }] },
    { "id": "daily-9", "day": 9, "rewards": [{ "type": "coins", "amount": 25 }] },
    { "id": "daily-10", "day": 10, "rewards": [{ "type": "coins", "amount": 30 }] },
    { "id": "daily-11", "day": 11, "rewards": [{ "type": "coins", "amount": 40 }] },
    { "id": "daily-12", "day": 12, "rewards": [{ "type": "coins", "amount": 50 }] },
    { "id": "daily-13", "day": 13, "rewards": [{ "type": "coins", "amount": 75 }] },
    { "id": "daily-14", "day": 14, "rewards": [{ "type": "inventory", "itemType": "avatar", "itemId": "royal", "gameId": null, "duplicateReward": { "type": "coins", "amount": 80 } }] },
    { "id": "daily-15", "day": 15, "rewards": [{ "type": "coins", "amount": 20 }] },
    { "id": "daily-16", "day": 16, "rewards": [{ "type": "coins", "amount": 25 }] },
    { "id": "daily-17", "day": 17, "rewards": [{ "type": "coins", "amount": 30 }] },
    { "id": "daily-18", "day": 18, "rewards": [{ "type": "coins", "amount": 40 }] },
    { "id": "daily-19", "day": 19, "rewards": [{ "type": "coins", "amount": 50 }] },
    { "id": "daily-20", "day": 20, "rewards": [{ "type": "coins", "amount": 75 }] },
    { "id": "daily-21", "day": 21, "rewards": [{ "type": "inventory", "itemType": "name_style", "itemId": "gold-serif", "gameId": null, "duplicateReward": { "type": "coins", "amount": 120 } }] },
    { "id": "daily-22", "day": 22, "rewards": [{ "type": "coins", "amount": 20 }] },
    { "id": "daily-23", "day": 23, "rewards": [{ "type": "coins", "amount": 25 }] },
    { "id": "daily-24", "day": 24, "rewards": [{ "type": "coins", "amount": 30 }] },
    { "id": "daily-25", "day": 25, "rewards": [{ "type": "coins", "amount": 40 }] },
    { "id": "daily-26", "day": 26, "rewards": [{ "type": "coins", "amount": 50 }] },
    { "id": "daily-27", "day": 27, "rewards": [{ "type": "coins", "amount": 75 }] },
    { "id": "daily-28", "day": 28, "rewards": [{ "type": "inventory", "itemType": "avatar_frame", "itemId": "emerald-halo", "gameId": null, "duplicateReward": { "type": "coins", "amount": 140 } }] },
    { "id": "daily-29", "day": 29, "rewards": [{ "type": "coins", "amount": 100 }] },
    { "id": "daily-30", "day": 30, "rewards": [{ "type": "inventory", "itemType": "avatar", "itemId": "gold", "gameId": null, "duplicateReward": { "type": "coins", "amount": 180 } }] }
  ]
}
